<template>
  <div
    class="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-4"
  >
    <template
      v-for="({ key, ...stat }, index) in props.stats"
      :key="key || index"
    >
      <slot
        :item-key="key"
        :item-index="index"
        :stat="stat"
      >
        <!-- suppress RequiredAttributes -->
        <StatChip
          v-bind="stat"
        />
      </slot>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Icon } from '~/utils/types'

interface Stat {
  icon: Icon
  label: string
  value?: any
  default?: string
  description?: string
}

const props = defineProps<{
  stats: ({ key?: string } & Stat)[]
}>()
</script>
